var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-resource-list"},[_c('ResourceList',{ref:"resourceList",attrs:{"addLabel":"Add Device","addRoute":!_vm.hideAddButton ? _vm.addRoute : null,"params":_vm.params,"query":_vm.query,"resource":_vm.resource,"renderAs":_vm.renderAs,"sortByOptions":_vm.sortByOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }